import Brending from "../Brending";
import SocialLinks from "../SocialLinks";

export default function Header() {
  return (
    <header id="intro" className="layout1">
      <div className="container-fluid p-0">
        <Brending />
        <SocialLinks />
      </div>
    </header>
  );
}
